import Vue from 'vue'
export function downloadFile(url) {
    if (!url || typeof url !== 'string') {
        Vue.prototype.$TsaToastV2.show({
            message: '下载失败',
            type: 'error'
        })
        return
    }
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}